import { entityReport, KeyValue } from '@api';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export function fetchKeyValues(entityTag: string, signal?: AbortSignal) {
  return wretchRequest<KeyValue[]>(
    entityReport.getEntityKeyValues.path(entityTag),
    {
      schema: entityReport.getEntityKeyValues.schema,
      signal,
    }
  );
}
